import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type ContextValueType } from '../types';
import META from './useTrackContextValueEdited.meta';

export type UseTrackContextValueEditedParams = {
  source: 'manual';
  value_type: ContextValueType;
  field_name: string;
  edit_type: 'value' | 'label' | 'ai_instruction';
};

export const useTrackContextValueEdited = () => {
  const { track } = useAnalyticsUtilities();

  const trackContextValueEdited = useCallback(
    (params: UseTrackContextValueEditedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackContextValueEdited };
};
